import React from "react";
//#region components
import { Grid, Skeleton } from "@mui/material";
//#endregion

const TitledContainerSkeleton: React.FC = (props) => {
  return (
    <Grid item container direction="column" spacing={5}>
      <Grid item container>
        <Skeleton width="50%" height="8px" />
      </Grid>
      <Grid item container spacing={1.5} direction="column">
        {[...Array(4)].map((val, index) => (
          <Grid key={index} item container>
            <Skeleton width="33%" height="8px" />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default TitledContainerSkeleton;
